import { journeyAction, } from './base';

import { JourneyActionStartVoiceInbound as JourneyActionStartVoiceBase, } from 'atlas-shared';

export const JourneyActionStartVoiceInbound = journeyAction({
  ...JourneyActionStartVoiceBase,
  icon: 'Voice',
});
